// extracted by mini-css-extract-plugin
export default {"container":"GradingPeriodsTab__container___KfG_W","gridWrapper":"GradingPeriodsTab__gridWrapper___tvyQs","emptyStateWrapper":"GradingPeriodsTab__emptyStateWrapper___KHjky"};